// extracted by mini-css-extract-plugin
export default {"container":"Approval_container__EqsLA"};